/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PartnerFormBlock from './PartnerFormBlock';
import { Link } from 'react-router-dom';

class PartnerCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: "",
    };
  }

  componentWillMount() {
    // for product with tabs get tab name from url and set as selectedtab to show only that product
    // selectedtab = for multicategory(canvas) url has partnerProduct & for singlecategory(abbb) url has product param in this.props.match.params
    this.props.match.params.partnerProduct
        && this.setState({
          selectedTab: this.props.match.params.partnerProduct.replace(this.props.match.params.partnerId, "").replace("-", "").replace(/-/g, " ").toUpperCase(),
        });
        this.props.PartnerDetailPageResponse.partnerType !== 'multiCategory' &&
        !this.props.match.params.partnerProduct && this.props.match.params.product
        && this.setState({
          selectedTab: this.props.match.params.product.replace(this.props.match.params.partnerId, "").replace("-", "").replace(/-/g, " ").toUpperCase(),
        });
    setTimeout(() => {
      this.state && this.props.tabs.length !== 0 && !this.state.selectedTab
            && this.setState({
              selectedTab: this.props.tabs[0].title,
            });
            this.setState({shouldDisplay: true})
    }, 800);
  }

  render() {
    const { selectedTab } = this.state;
    const { partnerType } = this.props.PartnerDetailPageResponse
    const path = partnerType === 'multiCategory' ? `/${this.props.match.params.partnerId}-${this.props.match.params.product.replace(`${this.props.match.params.partnerId}-`, "").toLowerCase()}` : '';
    const defaultTabpath = partnerType === 'multiCategory' ? `/partner/${this.props.match.params.partnerId}/${this.props.match.params.product}` : `/partner/${this.props.match.params.partnerId}`
    return (
      <div>
        {(() => {
          if (this.props.product_withTab.length !== 0 && this.state.shouldDisplay) {
            // filter data to display based on selected tab
            // replace(/-/g,"") because in case of selectedTab 'self study' it can match title which has self-study
            if (this.props.productData.title.replace(/-/g, " ").toUpperCase().includes(selectedTab.replace(/-/g, " "))) {
              return (
                <div className="partner-products">
                  {/* <!-- package selection starts --> */}
                  <div className="container package-selection-title-container">
                    <p className="package-selection-title" dangerouslySetInnerHTML={{ __html: this.props.productData.title }} />
                  </div>
                  <div className="container-fluid package-container">
                    <div className="container package-selection-core">
                      {/* <!-- platinum package starts --> */}
                      <div className="package-selection-container platinum-package">
                        {/* tabs length is one then show normal design without tabs, filtering tabs to remove duplicates */}
                        {this.props.tabs.filter((current, i, arr) => arr.findIndex((t) => (t.title === current.title)) === i).length > 1 && (
                        <div className="select-package-option-container-alignment">
                          <div className="d-inline-flex justify-content-center flex-row bd-highlight mb-3 select-package-option-container">
                            {this.props.tabs.filter((current, i, arr) => arr.findIndex((t) => (t.title === current.title)) === i).map((tab, i) => (
                              i === 0
                                ? (
                                  <Link to={defaultTabpath} key={tab.title} className="select-package-option-content"
                                  onClick={()=>{this.props.changeProduct(defaultTabpath)}}>
                                    <div className={`p-2 bd-highlight ${this.props.productData.title.toUpperCase().includes(tab.title) ? "platinum-package-option-selected" : ""}`}>
                                      <p className="course-option" id={tab.title}>{tab.title}</p>
                                    </div>
                                  </Link>
                                )
                                : (
                                  <Link to={`/partner/${this.props.match.params.partnerId}${path}/${this.props.match.params.partnerId}-${tab.title.replace(/ /g, "-").toLowerCase()}`} 
                                  key={tab.title} className="select-package-option-content"
                                  onClick={()=>{this.props.changeProduct(`/partner/${this.props.match.params.partnerId}${path}/${this.props.match.params.partnerId}-${tab.title.replace(/ /g, "-").toLowerCase()}`)}}>
                                    <div className={`p-2 bd-highlight ${this.props.productData.title.replace(/-/g, ' ').toUpperCase().includes(tab.title.replace(/-/g, ' ')) ? "platinum-package-option-selected" : ""}`}>
                                      <p className="course-option" id={tab.title}>{tab.title}</p>
                                    </div>
                                  </Link>
                                )
                            ))}
                          </div>
                        </div>
                        )}
                        <div className="row">
                          <div className="col-xs-12 col-sm-6 package-selection-col">
                            <>
                              {this.props && this.props.productData.description
                                ? <div dangerouslySetInnerHTML={{ __html: this.props.productData.description }} /> : <h1 className="formDataError">This Description is not available !</h1>}
                              <p hidden url={this.props.productData.url} />
                            </>
                          </div>
                          <div className="col-xs-12 col-sm-6 package-selection-col">
                            {this.props && this.props.productData
                              ? <PartnerFormBlock index={this.props.index} partnerId={this.props.partnerId} skuCode={this.props.productData.code} PackageForm={this.props.productData.variant} title={this.props.productData.title} />
                              : <h1 className="formDataError">This Product is not available !</h1>}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <!-- platinum package ends --> */}
                  </div>
                </div>
              );
            }
          }
          if (this.props.nonTabProduct.length !== 0) {
            return this.props.nonTabProduct.map((prod) => (prod.name === this.props.productData.title)
                  && (
                  <div className="partner-products" key={prod.name}>
                    {/* <!-- package selection starts --> */}
                    <div className="container package-selection-title-container">
                      <p className="package-selection-title" dangerouslySetInnerHTML={{ __html: this.props.productData.title }} />
                    </div>
                    <div className="container-fluid package-container">
                      <div className="container package-selection-core">
                        {/* <!-- platinum package starts --> */}
                        <div className="package-selection-container platinum-package">
                          <div className="row">
                            <div className="col-xs-12 col-sm-6 package-selection-col">
                              <>
                                {this.props && this.props.productData.description
                                  ? <div dangerouslySetInnerHTML={{ __html: this.props.productData.description }} /> : <h1 className="formDataError">This Description is not available !</h1>}
                                <p hidden url={this.props.productData.url} />
                              </>
                            </div>

                            <div className="col-xs-12 col-sm-6 package-selection-col">
                              {this.props && this.props.productData
                                ? <PartnerFormBlock index={this.props.index} partnerId={this.props.partnerId} skuCode={this.props.productData.code} PackageForm={this.props.productData.variant} title={this.props.productData.title} />
                                : <h1 className="formDataError">This Product is not available !</h1>}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!-- platinum package ends --> */}
                    </div>
                  </div>
                  ));
          }
        })()}
      </div>

    );
  }
}

export default PartnerCategory;
